import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import AdvertisementEditViewStore from "../../stores/AdvertisementEditViewStore";
import SavingStates from "../../constants/states/SavingStates";
import ImageUploaderStore from "../../stores/ImageUploaderStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import AdvertisementEditView from "../views/AdvertisementEditView";

class AdvertisementEditContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "advertisementEditViewStoreState": AdvertisementEditViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.advertisementEditViewStoreState.imageNames.currentValue !== this.state.advertisementEditViewStoreState.imageNames.currentValue) {
            EventPublisher.publish(UIInteractionEvents.LOAD_IMAGES_FOR_EDIT, {imageNames: this.state.advertisementEditViewStoreState.imageNames.currentValue});
        }
    }

    componentDidMount() {
        this.advertisementEditViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ADVERTISEMENT_EDIT_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        this.imageUploaderStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.IMAGE_UPLOADER_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_EDIT_SET_ADVERTISEMENT_ID, {"advertisementId": this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.advertisementEditViewStoreSubscriber);
        EventPublisher.unsubscribe(this.imageUploaderStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.REST_IMAGE_STORE, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "advertisementEditViewStoreState": AdvertisementEditViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        });
    };

    render() {
        return (
            <AdvertisementEditView
                isSaving={this.state.advertisementEditViewStoreState.savingState === SavingStates.SAVING}
                showingImageSlideIndex={this.state.imageUploaderStore.currentShownImageIndex}
                title={this.state.advertisementEditViewStoreState.title}
                description={this.state.advertisementEditViewStoreState.description}
                imageNames={this.state.imageUploaderStore.imageNames}
                uploadPercentage={this.state.imageUploaderStore.currentUploadPercentage()}
                isDirtyImages={this.state.advertisementEditViewStoreState.imageNames.isTouched}
                isEditable={this.state.advertisementEditViewStoreState.isEditable}
                advertisementId={this.props.match.params.id}
            />
        );
    }

}

export default AdvertisementEditContainer;